import { Avatar, message, Popover } from 'antd';
import { useEffect, useState } from 'react';
import { CiLogout } from 'react-icons/ci';
import { MdAdminPanelSettings } from 'react-icons/md';
import { SiNamecheap } from 'react-icons/si';
import { decodeToken } from 'react-jwt';
import { RiExchangeFundsFill } from 'react-icons/ri';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { resetUserLogoutApi, userLogoutApi } from '../../../redux/features/auth/UserLogout';
import ChangePassword from '../../features/authentication/change-password/changePassword';
import axios from 'axios';
import { useLogType } from '../../../context/LogTypeContext';
import { resetForgotPassword } from '../../../redux/features/auth/ForgotPassword';

const UserInfo = () => {
	const [userData, setUserdata] = useState<any>({}),
		dispatch = useDispatch(),
		navigate = useNavigate(),
		// status = useSelector((state: any) => state.logout.logoutStatus),
		{ logoutResponse, status: userLogoutApiLoad } = useSelector((state: any) => state?.userLogoutApi),
		{ userLoginApiRes, userLoginApiLoad } = useSelector((state: any) => state?.userLoginApi);
	const [changePassMdlDis, setChangePassMdlDis] = useState<boolean>(false);
	const changePassMdlOpen = (boolVal: boolean) => {
		setChangePassMdlDis(boolVal);
	};



	useEffect(() => {
		const myDecodedToken: any = decodeToken(sessionStorage?.accessToken);
		  //Retrieve authenticated user information from local storage
		  const authUser: any | null = localStorage.getItem("authUser") 
		  ? JSON.parse(localStorage.getItem("authUser") as string) 
		  : null;
		setUserdata(authUser?.value);
		// setUserdata(myDecodedToken);
	}, [userLoginApiRes, userLoginApiLoad]);

	useEffect(() => {
		if (status === 'success') {
			sessionStorage.clear();
			navigate('/');
		}
	}, [status, navigate]);

	useEffect(() => {
		getLabel();
		switch (logoutResponse?.status) {
			case 200:
				sessionStorage.clear();
				navigate('/');
				dispatch(resetUserLogoutApi());
				break;
			case 400:
				message.warning(logoutResponse.message);
				dispatch(resetUserLogoutApi());
				break;
			case 500:
				message.error(logoutResponse.message);
				dispatch(resetUserLogoutApi());
				break;
			default:
				break;
		}
	}, [logoutResponse, userLogoutApiLoad]);

	const [visible, setVisible] = useState(false);
	//state for set InfluencerLoginUser data
	const [isChangePasswordShow, setIsChangePasswordShow] = useState("")
	//funtion for get IsChangePasswordShow data
	const getLabel = async () => {
		const res = await axios.get("/Configuration.json")
		console.log(res.data)
		setIsChangePasswordShow(res.data.IsChangePasswordShow)
	}


		const { logtype, setLogtype ,isResendOtp, setIsResendOtp,isVerifyModalVisible, setIsVerifyModalVisible} = useLogType();

	const userMenuOptions = (
		<ul className="gx-user-popover" style={{ fontFamily: 'NoirPro' }}>
			<li style={{ display: 'flex', alignItems: 'center', width: '100%', gap: '5px', borderRadius: '5px' }}>
				<SiNamecheap size={18} />
				{/* {userData?.UserType ===  "SystemUser" ? 
			    userData?.UserName :
				userData?.FirstName	
			} */}
			{userData?.USERNAME}
			</li>

			<li style={{ display: 'flex', alignItems: 'center', width: '100%', gap: '5px', borderRadius: '5px' }}>
				<MdAdminPanelSettings size={18} />
				{/* {userData?.UserType === "SystemUser"?
				userData?.OrgLevelName :
				userData?.UserType		
			} */}
				{userData?.USERTYPE}
			</li>
			{isChangePasswordShow && (
			<li
				style={{ color: '#038fde', display: 'flex', alignItems: 'center', gap: '2px', width: '100%', borderRadius: '5px' }}
				onClick={() => {
					setChangePassMdlDis(true);
					setVisible(false); 
				}}
			>
				<RiExchangeFundsFill style={{ marginRight: '5px' }} /> Change Password
			</li>
			)}
			<li
				style={{ color: 'red', display: 'flex', alignItems: 'center', gap: '2px', width: '100%', borderRadius: '5px' }}
				onClick={() => {
					// dispatch(userLogoutApi());
					// sessionStorage.clear();
					dispatch(resetForgotPassword()); 
					setIsResendOtp(false)
					setIsVerifyModalVisible(false)
					localStorage.removeItem("authUser");
					navigate('/');
				}}			
			>
				<CiLogout style={{ marginRight: '5px' }} /> Log out
			</li>
		</ul>
	);

	return (
		<>
			{changePassMdlDis && <ChangePassword disMdl={true} trigger={changePassMdlOpen} />}
			<Popover
				overlayClassName="gx-popover-horizantal"
				placement="bottomRight"
				content={userMenuOptions}
				trigger="click"
				open={visible}
				onOpenChange={setVisible}
			>
				<Avatar src="/assets/images/userlogo.png" className="gx-avatar gx-pointer boxshadow" alt=""  />
			</Popover>
		</>
	);
};

export default UserInfo;
